import React from 'react';
import {observer} from 'mobx-react';
import './render-double-stack.scss';
import {ProductCustomizationState} from '../render.def';

interface Props {
    pcs: ProductCustomizationState;
}

export const RenderDoubleStack = observer(({pcs}: Props) => {
    return (
        <div
            id="frame-double-stack"
            style={{
                aspectRatio: pcs.css.double_stack_aspect_ratio,
                width: pcs.css.double_stack_is_vertical ? 'auto' : '80%',
                height: pcs.css.double_stack_is_vertical ? '100%' : '',
                backgroundImage: pcs.BackgroundPartURL,
            }}
        >
            <img
                id="document-image"
                alt="Document Image"
                src={pcs.css.doc1_src}
                style={{
                    width: `${pcs.css.double_stack_width}%`,
                    height: `${pcs.css.double_stack_height}%`,
                }}
            />
        </div>
    );
});
